import '../App.css';
import MainContent from '../components/MainContent';
import { useEffect, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, FormWhiteContainer, LightBlueContainer, ShortBlueButton, } from '../assets/style';
import { Box } from '@mui/material';
import FormLabel from '../components/FormLabel';
import { useLocation, useNavigate } from 'react-router';
import { userPageName } from '../components/PageName';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../features/auth/authSlice'
import { useLazyGetUserDetailQuery } from '../features/auth/authApiSlice';
import { UserDetailModel } from '../models/UserModel';

const UserDetailPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    const userId = getLocation.state?.userId;
    const [user, setUser] = useState<UserDetailModel | null>(null);
    const [getUserDetail, getUserDetailResult] = useLazyGetUserDetailQuery()

    const permissions = useSelector(selectPermissions)

    useEffect(() => {
        if (getLocation.state.user)
            setUser(getLocation.state.user)
        else if (userId) {
            getUserDetail(userId)
        }
    }, [])

    useEffect(() => {
        if (getUserDetailResult.isSuccess) {
            setUser(getUserDetailResult.data)
        }
    }, [getUserDetailResult.data])

    //Todo: Handle failures to get worker detail
    useEffect(() => { })

    return (
        <MainContent type={userPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <BigHeading>{t("User Detail")}</BigHeading>
                    {
                        permissions.includes("UserEdit") &&
                        <ShortBlueButton onClick={() => { navigate('/add-user', { state: { user } }); }}>{t("Edit")}</ShortBlueButton>
                    }
                    <FormLabel title={t("User Name")} value={user?.name} />
                    <FormLabel title={t("Company Name")} value={user?.companyName} />
                    <FormLabel title={t("Is Active")} value={user?.isActive ? "true" : "false"} />
                    {<FormLabel title={t("Email")} value={user?.email} />}
                    <FormLabel title={t("Role Name")} value={user?.roleName} />

                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        {/* <ShortBlueButton >{t("Save")}</ShortBlueButton> */}
                        <BackButton onClick={() => { navigate('/user') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default UserDetailPage